import { render } from "./Login_Black_FW.vue?vue&type=template&id=035667a0"
import script from "./Login_Black_FW.vue?vue&type=script&lang=js"
export * from "./Login_Black_FW.vue?vue&type=script&lang=js"

import "./Login_Black_FW.vue?vue&type=style&index=0&id=035667a0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__